import React, { useState } from 'react';
import Modal2 from 'components/_shared/Modal2';
import ReinstateFormBody from './components/ReinstateFormBody';
import AlertBody from './components/AlertBody';
import { reinstateRequest } from 'api/homelesses';
import {
    decodeApiErrorFromResponse,
    parseApiErrorMessage
} from 'util/parseApiErrorMessage';
import {
    ExtensionRequestKind,
    extensionRequestDescription
} from 'util/membershipHelper';

type ReinstateFormProps = {
    member: {
        id: number;
        name: string;
        photo: string;
        first_name?: string | null;
        pii_first_name?: string | null;
    };
    onClose: () => void;
    onFinish: () => void;
    onSubmitted?: () => void;
    closeButtonText?: string;
    deploymentName?: string | null;
    requestKind: ExtensionRequestKind;
};

const ReinstateForm: React.FC<ReinstateFormProps> = ({ member, onClose, onFinish, onSubmitted, closeButtonText, deploymentName, requestKind }) => {
    const [loading, setLoading] = useState(false);
    const [errorText, setErrorText] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);
    const handleSubmit = async (setSuccessFromParent: (value: boolean) => void, description: string) => {
        setLoading(true);
        setErrorText(null);

        try {
            const details = description.trim() || 'No additional details provided';
            const response = await reinstateRequest(
                member.id,
                extensionRequestDescription(requestKind, details)
            );
            
            if (response.ok) {
                setLoading(false);
                setSuccessFromParent(true);
                onSubmitted?.();
            } else {
                setErrorText(await decodeApiErrorFromResponse(response));
                setSuccess(false);
                setLoading(false);
            }
        } catch (error: any) {
            setErrorText(parseApiErrorMessage(error));
            setSuccess(false);
            setLoading(false);
        }
    };

    const greenIconStyle = {
        backgroundColor: '#E9FBF2',
        border: '2px solid #1B9757',
        color: '#1B9757',
        fontSize: '24px'
    };

    return (
        <Modal2
            onClose={onClose}
            additionalStyles={success ? { iconStyle: greenIconStyle } : {}}
            iconName={success ? 'fa-check' : ''}
            title="Reinstate Form"
        >
            {success ? (
                <AlertBody
                    title="Extension request submitted"
                    subtext={null}
                    titleColor="green"
                    closeButtonText={closeButtonText}
                    onClose={() => {
                        onFinish();
                    }}
                />
            ) : (
                <ReinstateFormBody
                    member={member}
                    loading={loading}
                    errorText={errorText || undefined}
                    onSubmit={handleSubmit}
                    setSuccess={setSuccess}
                    deploymentName={deploymentName}
                />
            )}
        </Modal2>
    );
};

export default ReinstateForm;
